module.exports = __webpack_public_path__ + "static/media/Sort A-z-blue.dafb5da2.svg";